import React, { Component } from "react";
import Slider from "react-slick";

class SmallImages extends Component {
	constructor(props) {
		super(props);
		this.state = {
			nav2: null,
		};
	}
	componentDidMount() {
		this.setState({
			nav2: this.slider2,
		});
	}

	render() {
		const { item, settings } = this.props;

		var productsnav = settings;

		return (
			<div className="row small-images">
				<div className="col-12 p-0">
					<Slider
						{...productsnav}
						asNavFor={this.props.navOne}
						ref={(slider) => (this.slider2 = slider)}
						className="slider-nav">
						{item.product_images.map(({ image }, index) => (
							<div key={index}>
								<img
									src={`${image}`}
									key={index}
									alt=""
									className="img-fluid"
								/>
							</div>
						))}
					</Slider>
				</div>
			</div>
		);
	}
}

export default SmallImages;
